import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
    selector: 'app-signup-welcome',
    standalone: true,
    imports: [CommonModule, RouterLink, LucideIconsModule],
    templateUrl: './signup-welcome.component.html',
    styleUrls: ['./signup-welcome.component.scss'],
})
export class SignupWelcomeComponent {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    protected themeService = inject(ThemeService);
    readonly logoBlackSrc = 'https://assetsnibni.zohostratus.com/images/logos/nibni-logo-black.avif';
    readonly logoWhiteSrc = 'https://assetsnibni.zohostratus.com/images/logos/nibni-logo-white.avif';

    goToAccount(type: 'investor' | 'partner'): void {
        void this.router.navigate([type === 'investor' ? '/signup/customer' : '/signup/developer'], {
            queryParams: { ...this.route.snapshot.queryParams }
        });
    }
}
